/**
 * meeting-order — in-phase display order for the meeting timeline (Release 1 meeting reorder).
 *
 * Mirrors the server ORDER BY in packages/meetings/handlers/list-project-meetings.ts:
 *   1. `sort_order` ascending — the canonical CASDM order seeded per row (V052). NULL (ad-hoc
 *      meetings) sorts AFTER every canonical meeting.
 *   2. `meeting_date` ascending, undated last.
 *   3. `meeting_name` as a stable, human-readable tie-break.
 * The old alphabetical sort put "Discovery Readout & Review" before "Kickoff Call".
 */
export interface OrderableMeeting {
  meeting_name: string;
  meeting_date: string | null;
  sort_order?: number | null;
}

function dateKey(value: string | null): number | null {
  if (!value) return null;
  const t = Date.parse(value);
  return Number.isNaN(t) ? null : t;
}

/** Nulls last for both keys. */
function compareNullable(a: number | null, b: number | null): number {
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  return a - b;
}

export function compareMeetingsInPhase(
  a: OrderableMeeting,
  b: OrderableMeeting,
): number {
  return (
    compareNullable(a.sort_order ?? null, b.sort_order ?? null) ||
    compareNullable(dateKey(a.meeting_date), dateKey(b.meeting_date)) ||
    a.meeting_name.localeCompare(b.meeting_name)
  );
}
